<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="sourceId">
    <th mat-header-cell class="header" *matHeaderCellDef>Código</th>
    <td mat-cell *matCellDef="let element">
      {{ element.sourceId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let element">
      {{ element.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="document">
    <th mat-header-cell class="header" *matHeaderCellDef>Inscrição</th>
    <td mat-cell *matCellDef="let element">
      {{ element.document }}
    </td>
  </ng-container>

  <ng-container matColumnDef="administrator">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Código Administrador
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.administrator }}
    </td>
  </ng-container>

  <ng-container matColumnDef="SettlementDateApplicationDays">
    <th mat-header-cell class="header" *matHeaderCellDef>
      DiasLiquidFinEntrada
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.SettlementDateApplicationDays }}
    </td>
  </ng-container>

  <ng-container matColumnDef="SettlementDateRedemptionDays">
    <th mat-header-cell class="header" *matHeaderCellDef>DiasLiquidFinSaida</th>
    <td mat-cell *matCellDef="let element">
      {{ element.SettlementDateRedemptionDays }}
    </td>
  </ng-container>

  <ng-container matColumnDef="SettlemenDateApplicationMethod">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Aplicacao Criterio Contagem Dias
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.SettlemenDateApplicationMethod }}
    </td>
  </ng-container>

  <ng-container matColumnDef="SettlemenDateRedemptionMethod">
    <th mat-header-cell class="header" *matHeaderCellDef>
      TipoCalculoResgLiqfin
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.SettlemenDateRedemptionMethod }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ConversionDateApplicationDays">
    <th mat-header-cell class="header" *matHeaderCellDef>
      DiasLiquidFisEntrada
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.ConversionDateApplicationDays }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ConversionDateRedemptionDays">
    <th mat-header-cell class="header" *matHeaderCellDef>DiasLiquidFisSaida</th>
    <td mat-cell *matCellDef="let element">
      {{ element.ConversionDateRedemptionDays }}
    </td>
  </ng-container>

  <ng-container matColumnDef="ConversionDateRedemptionMethod">
    <th mat-header-cell class="header" *matHeaderCellDef>
      TipoCalculoResgConv
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.ConversionDateRedemptionMethod }}
    </td>
  </ng-container>

  <ng-container matColumnDef="RedemptionBaseMeasurementDateType">
    <th mat-header-cell class="header" *matHeaderCellDef>TipoBaseCalculo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.RedemptionBaseMeasurementDateType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="IsFIDC">
    <th mat-header-cell class="header" *matHeaderCellDef>
      CodigoTipoClassificacao
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isFIDC }}
    </td>
  </ng-container>

  <ng-container matColumnDef="MnemonicCode">
    <th mat-header-cell class="header" *matHeaderCellDef>
      CodigoMnemonicoCetip
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.mnemonicCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Scheme">
    <th mat-header-cell class="header" *matHeaderCellDef>
      CodigoFormaCondominio
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.scheme }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="ColumnsQuota.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsQuota"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsQuota"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
